import { MantineColor } from '@mantine/core';

export type BadgeType = 'DEFAULT' | 'COMPETITORS' | 'MACRO' | 'OPERATIONS' | 'CLOSED' | 'ACTIVE';

export enum BadgeInsightType {
  DEFAULT = 'Общая',
  COMPETITORS = 'Конкуренты',
  MACRO = 'Макро',
  OPERATIONS = 'Опер деятельность',
}

export const BADGE_COLOR_MAP: Record<BadgeType, MantineColor> = {
  DEFAULT: 'gray',
  COMPETITORS: 'indigo',
  MACRO: 'teal',
  OPERATIONS: 'yellow',
  CLOSED: 'teal',
  ACTIVE: 'yellow',
};

export const INSIGHT_BADGE_COLOR_MAP: Record<BadgeInsightType, MantineColor> = {
  [BadgeInsightType.DEFAULT]: BADGE_COLOR_MAP.DEFAULT,
  [BadgeInsightType.COMPETITORS]: BADGE_COLOR_MAP.COMPETITORS,
  [BadgeInsightType.MACRO]: BADGE_COLOR_MAP.MACRO,
  [BadgeInsightType.OPERATIONS]: BADGE_COLOR_MAP.OPERATIONS,
};

export const UNKNOWN_INSIGHT_BADGE_COLOR: MantineColor = 'grape';
